import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React from 'react';
import westImg from 'src/assets/img/westImg.png';
import fsImg from 'src/assets/img/fsImg.png';
import logImg from 'src/assets/img/logImg.png';
import lianiImg from 'src/assets/img/lianiImg.png';
import { TiFlash } from 'react-icons/ti';
import { FaCircleExclamation } from 'react-icons/fa6';
import { getRemovetzTime } from 'src/utils/function';
import { Tooltip } from 'flowbite-react';
import { BsDot } from 'react-icons/bs';
import { jobStatus } from 'src/constants/general';
const TopRequestorDatatable = ({ jobListData, modalOpenTopResponsive }: any) => {
    const Getcomp = (row: any) => (
        <div className="flex items-center gap-1">
            <img className="w-6 h-6 rounded-full" src={row.companyName === 'West' ? westImg : row.companyName === 'Log' ? logImg : row.companyName === 'Liani' ? lianiImg : fsImg} alt="img" />
            <div className="text-black text-xs font-medium font-['Satoshi Variable'] uppercase">{row.companyName}</div>
        </div>
    );
    const Getjobtype = (row: any) => (
        <div className="flex items-center">
            <div className="flex items-center gap-0 relative">
                {row.isAsap ? (
                    <span className="w-5 h-5 rounded-full bg-red-50 text-red500 flex justify-center items-center mr-1 absolute left-[-25px]">
                        <TiFlash />
                    </span>
                ) : (
                    ''
                )}
                {row.isMandatory ? (
                    <span className={`iconresponsive w-5 h-5 rounded-full bg-white text-blue-800 flex justify-center items-center mr-1 absolute ${row.isAsap ? 'left-[-50px]' : 'left-[-25px]'}`}>
                        <FaCircleExclamation size={30} />
                    </span>
                ) : (
                    ''
                )}
            </div>
            <div className="text-black text-xs font-medium font-['Satoshi Variable'] uppercase">{row.jobType}</div>
        </div>
    );
    const GetStartDate = (row: any) => getRemovetzTime(row.startDate, 'MMM. DD, YY');

    const GetEndDate = (row: any) => {
        if (row.endDate) {
            return getRemovetzTime(row.endDate, 'MMM. DD, YY');
        } else {
            return (
                <div className="">
                    <p className="px-5">-</p>
                </div>
            );
        }
    };
    const Getassignemply = (row: any) => {
        const employee = () => (
            <div>
                {row.employeeList.map((data: any, index: number) => (
                    <p className="truncate" key={index}>{`${data.name} ${data.surname}`}</p>
                ))}
            </div>
        );

        return row?.employeeList?.length === 1 ? (
            <p className="truncate">{`${row.employeeList[0].name} ${row.employeeList[0].surname}`}</p>
        ) : (
            <div className="flex">
                <p className="truncate me-[6px]">{`${row.employeeList[0].name} ${row.employeeList[0].surname}..`}</p>
                <Tooltip className="bg-black text-white" content={<>{employee()}</>}>
                    <div className="w-4 h-4 px-2 pt-0.5 pb-1 bg-indigo-500 rounded-2xl flex-col justify-center items-center gap-2 inline-flex">
                        <div className="text-white text-xs font-medium font-['Satoshi Variable']">{row?.employeeList?.length}</div>
                    </div>
                </Tooltip>
            </div>
        );
    };
    const Getstatus = (row: any) => {
        const statusColors: any = {
            [jobStatus.complete]: 'bg-Green20 text-Green80',
            [jobStatus.cancel]: 'bg-purpleLight text-purple80',
            [jobStatus.fail]: 'bg-red20 text-red500',
            [jobStatus.inprogress]: 'bg-yellow20 text-yellow80',
            [jobStatus.invoiced]: 'bg-secondary20 text-secondary',
        };

        const isColor = statusColors[row.status] || '';
        return (
            <div className={`h-6 pe-2 min-w-24 py-1 ${isColor} rounded-lg justify-center items-center inline-flex`}>
                <div>
                    <BsDot size={18} />
                </div>
                <div className={`text-xs font-medium`}>{row.status}</div>
            </div>
        );
    };

    return (
        <div className="pt-4">
            <div className="text-center text-zinc-800 text-lg font-medium font-['Satoshi Variable']">{modalOpenTopResponsive}</div>
            <div className={`${modalOpenTopResponsive === 'Top Requestor' ? 'h-[calc(100vh-150px)]' : ''} scrollbar-hide overflow-y-auto`}>
                <DataTable value={jobListData} tableClassName="logdatatable jobdatatable" emptyMessage="No Job Record Found" className="">
                    <Column field="comp" header="Comp." body={Getcomp}></Column>
                    <Column field="jobtype" header="Job type" body={Getjobtype}></Column>
                    <Column field="jobConfirmation" header="Job ID"></Column>
                    <Column field="assignemply" header="Assigned Employee" body={Getassignemply}></Column>
                    <Column field="location" header="Location"></Column>
                    <Column field="startdate" header="Start Date" body={GetStartDate}></Column>
                    <Column field="enddate" header="End Date" body={GetEndDate}></Column>
                    <Column field="departmentName" header="Department"></Column>
                    <Column field="status" header="Status" body={Getstatus}></Column>
                </DataTable>
            </div>
        </div>
    );
};
export default TopRequestorDatatable;
